import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteSchema } from '@api/schemaConfig';

import { IDeleteSchemaDTO } from '@interfaces/cmModule/schemaConfig';
import { TDefaultDTO } from '@interfaces/common/defaultDTO';
import { TConfigMutation } from '@interfaces/common/handlers';

import { EMenuActionsTypes, ESnackbarTypes } from '@enums/common';

import {
	MAVENIR_SCHEMA_CONFIG,
	SCHEMA_CONFIG_DELETE,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface ISchemaDeleteDeleteReturnType {
	deleteSchemaConfig: (data: IDeleteSchemaDTO) => void;
	isLoadingDeleteSchemaConfig: boolean;
}

export function useMutateSchemaDelete(
	props?: TConfigMutation<TDefaultDTO>,
): ISchemaDeleteDeleteReturnType {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const { onSuccess, filter } = props || {};

	const {
		mutate: deleteSchemaConfig,
		isLoading: isLoadingDeleteSchemaConfig,
	} = useMutation<IDeleteSchemaDTO>({
		mutationKey: [SCHEMA_CONFIG_DELETE],
		mutationFn: ({
			ids,
			actionType,
			presetName,
		}: IDeleteSchemaDTO) => {
			const deleteData = {
				filter: (actionType === EMenuActionsTypes.allFiltered) && filter
					? filter
					: undefined,
				ids,
				isAll: presetName
					? undefined
					: actionType === EMenuActionsTypes.all || actionType === EMenuActionsTypes.allFiltered,
				presetName,
			};

			return deleteSchema(deleteData);
		},
		onSuccess: () => {
			if (onSuccess) onSuccess();

			dispatch(setSnackbar({
				message: responseMessages.deleteDataModelConfig,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([MAVENIR_SCHEMA_CONFIG])];
		},
	});

	return {
		deleteSchemaConfig,
		isLoadingDeleteSchemaConfig,
	};
}
